export enum Reaction {
  THUMBS_UP = '+1',
  THUMBS_DOWN = '-1',
}
